import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import { PlacementFrontend } from '@post-office/browser--jsm-sequoia/jira-navbar-assets-app-section';

import { type PlacementRenderProps } from '@post-office/browser--jsm-sequoia/jira-navbar-assets-app-section';

import type { MessageTemplateContext } from '../../..';

import { AssetsPremiumTrialItem } from '../../../components/assets-premium-trial-item';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

type MessageFrontendProps = MessageTemplateContext & PlacementRenderProps;

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<MessageFrontendProps>(),
		Component: ({ dismiss, onItemClick, onItemViewed }: MessageFrontendProps) => (
			<AssetsPremiumTrialItem
				dismiss={dismiss}
				onItemClick={onItemClick}
				onItemViewed={onItemViewed}
			/>
		),
	},
});
